/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class ZoneCass extends Logic
{
  getControl (userID)
  {
    const entry = this.cass.control.find(entry => entry.user === userID);

    return entry ? entry.value : 0;
  }


  updateControl (user, value)
  {
    const control = this.cass.control.filter(entry => entry.user !== user);

    if (value > 0)
    {
      control.push({ user, value });
    }

    this.object.set({ control });
  }


  updateCurrentUser (user)
  {
    this.object.set({ currentUser: user });
  }


};
